var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 512,
  height: 512,
  viewBox: "0 0 135.467 135.467",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M79.042 47.456l6.455 6.641zm6.314 0l-6.548 6.688z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 1.72
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.489,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M8.481 122.697h116.196v.199H8.481z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.302,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M17.355 125.622h62.456v.283H17.355z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.158,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M84.838 125.559h32.32v.433h-32.32z"
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.489 15.344v97.186h74.765V38.847H81.886V15.306zm50.527-.153l24.366 23.54z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.83
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M82.247 27.176V15.882l.128.126c.14.139 5.91 5.725 16.283 15.766 3.653 3.535 6.701 6.488 6.775 6.562l.134.134h-23.32z",
  fill: "#d21e1e",
  fillOpacity: 0.747,
  paintOrder: "markers stroke fill"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d21e1e",
  fillOpacity: 0.076,
  paintOrder: "stroke fill markers",
  d: "M34.925 19.069h10.583v90.188H34.925zm67.839 79.661v10.583H48.217V98.73z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M60.943 72.974c5.946-1.227 13.476-1.35 21.047.327-6.734-1.442-14.279-1.73-21.047-.327z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 2.117
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M57.693 47.731l6.454 6.642zm6.314 0l-6.548 6.688z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 1.72
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.91 63.895v-48.09h49.52v23.48h24.386v72.701H31.91zm70.894 40.189V98.74H48.166v10.687h54.638zM45.57 64.159l-.038-45.118-5.306-.04-5.306-.04v90.316h10.688zm36.462 9.332c.095-.476.184-.966.2-1.09.02-.171-.395-.302-1.78-.558-3.589-.663-5.811-.855-9.934-.858-3.817-.003-5.053.088-8.328.612l-1.555.249.096.54c.168.935.387 1.67.498 1.666.06-.001.897-.133 1.863-.292 4.978-.822 11.3-.715 16.621.28 2.26.423 2.12.456 2.32-.55zM59.516 53.698l1.291-1.393 1.385 1.4 1.384 1.4.658-.659.658-.658-1.355-1.43-1.354-1.432 1.27-1.264c.698-.695 1.27-1.308 1.27-1.362 0-.054-.31-.352-.69-.664l-.691-.566-1.278 1.263-1.278 1.263-1.173-1.242c-.644-.683-1.235-1.242-1.312-1.242-.077 0-.4.268-.72.595L57 48.3l1.245 1.365 1.245 1.364-1.37 1.396-1.368 1.396.634.634c.348.349.68.634.735.634.056 0 .683-.627 1.394-1.392zm21.37-.301l1.287-1.393 1.346 1.43 1.345 1.43.688-.667.687-.667-1.37-1.417-1.372-1.417L84.8 49.39l1.3-1.31-.68-.667-.68-.668-1.279 1.271-1.278 1.271-1.277-1.27-1.278-1.271-.604.59c-.332.324-.604.659-.604.744 0 .085.554.71 1.232 1.392l1.23 1.237-1.419 1.449-1.419 1.448.677.587c.373.322.723.588.777.59.055.003.68-.622 1.387-1.387z",
  fill: "none"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.4b6f420494d5e2e8acbb8c4388f61ef9.svg";